import React from 'react';
import {
  locationVerificationLines,
  type VerificationPlace,
  type VerificationSubject
} from 'utils/locationVerification';

interface LocationVerificationProps {
  subject: VerificationSubject;
  place: VerificationPlace;
}

const formatTimestamp = (value: string | null) =>
  value ? new Date(value).toLocaleString() : 'None recorded';

/** The Location Information verification lines; see utils/locationVerification. */
const LocationVerification: React.FC<LocationVerificationProps> = ({
  subject,
  place
}) => {
  const { rtlsAt, verifiedLine, manualCheckAt, showManualCheck } =
    locationVerificationLines(subject, place);

  return (
    <div data-testid="location-verification">
      <p className="text-sm text-gray-600 mb-1">
        Last RTLS update: {formatTimestamp(rtlsAt)}
      </p>
      {verifiedLine && <p className="text-sm text-gray-600 mb-1">{verifiedLine}</p>}
      {showManualCheck && (
        <p className="text-sm text-gray-600 mb-1">
          Last manual check: {formatTimestamp(manualCheckAt)}
        </p>
      )}
    </div>
  );
};

export default LocationVerification;
